'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _forms = require('metadata/forms');

var _forms2 = require('utils/forms');

var _components2 = require('components');

var _insuranceInformation = require('../../../utils/mappings/insurance-information');

var _links = require('../../../utils/mappings/links');

var _FormLink = require('../../forms/FormLink');

var _FormLink2 = _interopRequireDefault(_FormLink);

var _utils = require('../../../utils/mappings/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InsuranceInformation = function InsuranceInformation(_ref) {
    var intl = _ref.intl,
        isPrimaryCustomerLoading = _ref.isPrimaryCustomerLoading,
        countryCode = _ref.countryCode,
        hiddenValues = _ref.hiddenValues,
        requirementsByCode = _ref.requirementsByCode,
        bookingId = _ref.bookingId,
        bookingCompanyId = _ref.bookingCompanyId,
        isFetchingRequirementData = _ref.isFetchingRequirementData,
        handleSubmit = _ref.handleSubmit,
        error = _ref.error,
        invalid = _ref.invalid,
        pristine = _ref.pristine,
        submitSucceeded = _ref.submitSucceeded,
        submitFailed = _ref.submitFailed,
        submitting = _ref.submitting;

    var language = intl.locale;
    var bookingConditionLink = (0, _utils.getLink)(bookingCompanyId, _links.BOOKING_CONDITIONS_LINK_MAP, countryCode);
    var insuranceService = requirementsByCode.INSURANCE_DETAILS;
    var valuePath = (0, _forms2.generateValuePath)({
        requirement: insuranceService,
        resourceType: 'insurance_services'
    });

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components2.FormErrorMessage, { errorCode: error, invalid: invalid, submitFailed: submitFailed, submitting: submitting }),
        _react2.default.createElement(_components2.FormInstructionalText, {
            instructionalText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'formInsuranceInformation.instructionalText',
                defaultMessage: '{insuranceInformation}',
                values: {
                    insuranceInformation: _react2.default.createElement(
                        'div',
                        null,
                        _insuranceInformation.INSURANCE_POLICY_MAP[language][bookingCompanyId],
                        ' \xA0',
                        !isPrimaryCustomerLoading && bookingConditionLink && _react2.default.createElement(
                            _FormLink2.default,
                            { link: bookingConditionLink },
                            'Booking Conditions'
                        )
                    )
                } }) }),
        _react2.default.createElement(
            'form',
            null,
            _react2.default.createElement(_components2.FieldSet, {
                requirement: insuranceService,
                fields: [{
                    id: 'start_date',
                    label: intl.formatMessage(_forms.formLabels.startDate),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'start_date',
                        name: valuePath + '.start_date',
                        hiddenValues: hiddenValues,
                        component: _components2.SeparatedDateInput,
                        type: 'text',
                        placeholder: intl.formatMessage(_forms.formPlaceholders.dateFormat),
                        requirement: insuranceService,
                        helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formInsuranceInformation.startDateInfoText',
                            defaultMessage: '{dateTextStart}',
                            values: {
                                dateTextStart: _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'If you don\'t have an start date on your policy, ',
                                        _react2.default.createElement('br', null),
                                        'put the first day of the tour.'
                                    )
                                )
                            } })
                    })
                }, {
                    id: 'finish_date',
                    label: intl.formatMessage(_forms.formLabels.finishDate),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'finish_date',
                        name: valuePath + '.finish_date',
                        hiddenValues: hiddenValues,
                        component: _components2.SeparatedDateInput,
                        type: 'text',
                        placeholder: intl.formatMessage(_forms.formPlaceholders.dateFormat),
                        requirement: insuranceService,
                        helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formInsuranceInformation.endDateInfoText',
                            defaultMessage: '{dateTextEnd}',
                            values: {
                                dateTextEnd: _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'If you don\'t have an end date on your policy, ',
                                        _react2.default.createElement('br', null),
                                        'put the last day of the tour.'
                                    )
                                )
                            }
                        })
                    })
                }, {
                    id: 'policy_number',
                    label: intl.formatMessage(_forms.formLabels.policyNumber),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'policy_number',
                        name: valuePath + '.policy_number',
                        hiddenValues: hiddenValues,
                        component: _components2.Input,
                        type: 'text',
                        requirement: insuranceService })
                }, {
                    id: 'policy_emergency_phone_number',
                    label: intl.formatMessage(_forms.formLabels.policyEmergencyPhoneNumber),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'policy_emergency_phone_number',
                        name: valuePath + '.policy_emergency_phone_number',
                        hiddenValues: hiddenValues,
                        component: _components2.Input,
                        type: 'tel',
                        parse: _forms2.parsePhone,
                        requirement: insuranceService })
                }, {
                    id: 'policy_provider',
                    label: intl.formatMessage(_forms.formLabels.policyProvider),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: 'policy_provider',
                        name: valuePath + '.policy_provider',
                        hiddenValues: hiddenValues,
                        component: _components2.Input,
                        type: 'text',
                        requirement: insuranceService })
                }] }),
            _react2.default.createElement(_components2.FormSubmit, {
                handleSubmit: handleSubmit,
                invalid: invalid,
                pristine: pristine,
                submitting: submitting,
                submitSucceeded: submitSucceeded,
                isFetchingRequirementData: isFetchingRequirementData })
        )
    );
};
InsuranceInformation.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    requirementsByCode: _propTypes2.default.object.isRequired,
    bookingId: _propTypes2.default.string.isRequired,
    bookingCompanyId: _propTypes2.default.number.isRequired,
    isFetchingRequirementData: _propTypes2.default.bool.isRequired,
    handleSubmit: _propTypes2.default.func.isRequired,
    error: _propTypes2.default.string,
    invalid: _propTypes2.default.bool,
    pristine: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    submitSucceeded: _propTypes2.default.bool,
    submitFailed: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reduxForm.reduxForm)({
    form: 'insuranceInformation',
    enableReinitialize: true
})(InsuranceInformation));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/forms/InsuranceInformation.js
// module id = 1322
// module chunks = 0